import { Button, Menu } from '@mui/material';
import styled from 'styled-components';

interface AppMenuProps {
  logged: boolean;
}

const AppMenuStyled = styled.div`
  visibility: ${(props: AppMenuProps) => (props.logged ? 'visible' : 'hidden')};
  height: ${(props: AppMenuProps) => (props.logged ? '64px' : '0px')};
  opacity: ${(props: AppMenuProps) => (props.logged ? '1' : '0')};
  padding: ${(props: AppMenuProps) => (props.logged ? '10px' : '0px')};
  background-color: rgb(69, 69, 69);
  transition: visibility 0.5, opacity 0.5 linear;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: ${(props: AppMenuProps) => (props.logged ? '100vw' : '0vw')};
`;

const UserMenu = styled(Menu)``;

const MenuStyled = styled.div`
  flex: 1;
  position: relative;
  gap: 8px;
  display: flex;
`;
const AppMenuInfo = styled.div``;
const AppMenuConfig = styled.div``;

const MenuButton = styled(Button)`
  text-transform: capitalize !important;
  margin-left: 10px !important;
  margin-right: 10px !important;
  white-space: nowrap;
  overflow: hidden;
  letter-spacing: 0.5px !important;
`;

const ConfigButton = styled(Button)`
  text-transform: capitalize !important;
  margin-left: -10px !important;
  margin-right: -10px !important;
`;

export { AppMenuStyled, UserMenu, MenuStyled, AppMenuInfo, AppMenuConfig, MenuButton, ConfigButton };
